import React from 'react';
import './Popup.css'; // Assuming you have some basic CSS for styling

//{amount, description, flow, from, name, projectID, transactionMode, to, transactionDate, transactionStatus}
const TransactionPopup = ({ item, onClose }) => {
    return (
        <div className="popup-overlay" onClick={onClose}>
            <div className="popup-content" onClick={(e) => e.stopPropagation()}>
                <h2>Transaction Details</h2>
                <p><strong>Project ID:</strong> {item.projectID}</p>
                <p><strong>Name:</strong> {item.name}</p>
                <p><strong>From:</strong> {item.from}</p>
                <p><strong>To:</strong> {item.to}</p>
                <p><strong>Amount:</strong> {item.amount}</p>
                <p><strong>Transaction Date:</strong> {new Date(item.transactionDate).toLocaleDateString()}</p>
                <p><strong>Description:</strong> {item.description || '-'}</p>
                <p><strong>Flow:</strong> {item.flow === 1 ? 'Outgoing' : 'Incoming'}</p>
                <p><strong>Transaction Mode:</strong> {item.transactionMode}</p>
                <p><strong>Transaction Status:</strong> {item.transactionStatus === 1 ? 'Completed' : 'Pending'}</p>
                <button onClick={onClose}>Close</button>
            </div>
        </div>
    );
};

export default TransactionPopup;
